import { jsx } from "panel";
import { selx } from "clsx";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { InputSize } from "common/components/input/types";
import { CopyToClipboardButtonEl } from "./copy-to-clipboard-button";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-copy-to-clipboard", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { sel: selx(".copy-input", {
    ".full-width": this.attr("full-width")
  }), attrs: {
    readonly: true,
    type: "text",
    label: this.attr("label"),
    size: this.attr("size") || InputSize.Large
  }, props: {
    value: this.attr("value")
  }, hook: {
    insert: (_ref) => {
      let {
        elm
      } = _ref;
      return this.helpers.handleInsert(elm);
    }
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(CopyToClipboardButtonEl, { sel: ".copy-button", attrs: {
    options: [{
      value: this.attr("value")
    }],
    size: this.attr("size") || ButtonSize.Large,
    theme: ButtonTheme.Tertiary
  }, "data-sentry-element": "CopyToClipboardButtonEl", "data-sentry-source-file": "template.tsx" }, !this.attr("icon-only") && this.t("components.copy-to-clipboard.copy")));
}
